import React, { useState, useEffect } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import {
  Assignment as AssignmentIcon,
  Flight as FlightIcon,
  PendingActions as PendingActionsIcon,
  Description as DescriptionIcon
} from '@mui/icons-material';
import CrewAssignments from './CrewAssignments';
import CrewDutyRosterView from './CrewDutyRosterView';
import AvailabilityAndLeave from './AvailabilityAndLeave';

/**
 * CrewInbox-part2.js
 * 
 * This file contains the full implementation of CrewInbox.
 * CrewInbox.js is a thin wrapper that imports from this file.
 * 
 * This split was done to keep file sizes manageable (500-600 lines per file).
 */
const CrewInboxPart2 = () => {
  const [tabValue, setTabValue] = useState(0); // 0: Assignments, 1: My Duty Roster, 2: Availability & Leave

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Crew Portal
      </Typography>

      <Tabs
        value={tabValue}
        onChange={(e, newValue) => setTabValue(newValue)}
        sx={{ mb: 3 }}
      >
        <Tab icon={<AssignmentIcon />} label="Assignments" />
        <Tab icon={<FlightIcon />} label="My Duty Roster" />
        <Tab icon={<PendingActionsIcon />} label="Availability & Leave" />
      </Tabs>

      {tabValue === 0 && <CrewAssignments />}
      {tabValue === 1 && <CrewDutyRosterView />}
      {tabValue === 2 && <AvailabilityAndLeave />}
    </Box>
  );
};

export default CrewInboxPart2;

